export default __webpack_public_path__ + "static/media/zip.8558d578.png";